exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".global__a11yOnly--3n7m7{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.global__a11yOnly--3n7m7.global__focusable--_TM4N:active,.global__a11yOnly--3n7m7.global__focusable--_TM4N:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}", ""]);

// exports
exports.locals = {
	"a11yOnly": "global__a11yOnly--3n7m7",
	"focusable": "global__focusable--_TM4N"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./src/styles/global.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./src/styles/global.css
// module chunks = 1